
import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { ScorecardLicenseSummary } from './ScorecardLicenseSummary';
import { ScorecardTable } from './ScorecardLicenseTableColumn';
import { CustomDialogTitle } from '../../Common/Custom/CustomDialogTitle';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { userRolesState } from '../../../State/user.Atom';
import { useRecoilValue } from 'recoil';
import { SubAdminRole, SiteAdminRole, UserAdminRole } from '../../../Component/Common/Constants/UserRoles';

interface IScorecardLicense {
  scorecardData: ScorecardTable;
  entriesPerPage: EntriesPerPage;
  pageNumber: number;
  filteredItemsCount: number;
  totalItemsCount: number;
  entriesPerPageChanged: (entriesPerPage: number) => void;
  pageNumberChanged: (pageNumber: number) => void;
  searchValueChanged: (searchValue: string) => void;
  columnSortingChanged: (sortOption: ColumnSortOption) => void;
  isLoading: boolean;
}

export const ScorecardLicense = (props: IScorecardLicense) => {

  const [showModal, setShowModal] = React.useState<boolean>(false);
  const userRoles = useRecoilValue(userRolesState);

  const handleAddScoredcard = () => {
    setShowModal(true);
  }

  const bulkActions = [
    {
      label: "Add Scorecard",
      action: handleAddScoredcard
    }
  ]
  return (
    <>
      <DataTable
        key={props.totalItemsCount}
        table={props.scorecardData}
        canSearch
        entriesPerPage={props.entriesPerPage}
        pageNumber={props.pageNumber}
        filteredItemsCount={props.filteredItemsCount}
        totalItemsCount={props.totalItemsCount}
        entriesPerPageChanged={props.entriesPerPageChanged}
        pageNumberChanged={props.pageNumberChanged}
        searchValueChanged={props.searchValueChanged}
        isLoading={props.isLoading}
        manualSorting={true}
        columnSortingChanged={props.columnSortingChanged}
        {...((userRoles.includes(SiteAdminRole) || userRoles.includes(UserAdminRole)) ? { bulkActions } : {})}
      ></DataTable>

      <Dialog open={showModal} onClose={() => setShowModal(false)} aria-labelledby="form-dialog-title" maxWidth='xl'>
        <CustomDialogTitle id="customized-dialog-title" onClose={() => setShowModal(false)}>
          Add Scorecard
        </CustomDialogTitle>
        <DialogContent>
          <ScorecardLicenseSummary />
        </DialogContent>
      </Dialog>
    </>
  )
}

